/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Users_Settings_Login_ExtensionInputs */

const en_forms_users_settings_login_extension = /** @type {(inputs: Forms_Users_Settings_Login_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extension`)
};

const de_forms_users_settings_login_extension = /** @type {(inputs: Forms_Users_Settings_Login_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durchwahl`)
};

/**
* | output |
* | --- |
* | "Extension" |
*
* @param {Forms_Users_Settings_Login_ExtensionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_users_settings_login_extension = /** @type {((inputs?: Forms_Users_Settings_Login_ExtensionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Users_Settings_Login_ExtensionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_users_settings_login_extension(inputs)
	return de_forms_users_settings_login_extension(inputs)
});